import { t } from "i18next";
import { AvailabilitySlotProgress } from "@/types";
import cn from "classnames";
import BlockIcon from "@/components/icons/BlockIcon.tsx";
import CrossIcon from "@/components/icons/availability/CrossIcon.tsx";
import CheckIcon from "@/components/icons/availability/CheckIcon.tsx";

interface IProps {
  id: string;
  value: {
    day: string;
    time: string;
  };
  isSelected: boolean;
  setIsSelected?: (value: {
    id: string;
    value: {
      day: string;
      time: string;
    };
    isSelected: boolean;
  }) => void;
  excludeDate: boolean;
  disabled: boolean;
  className?: string;
  state: number | undefined;
  blockInsert: boolean;
}

function AvailabilityItem(props: IProps) {
  const {
    state,
    isSelected,
    setIsSelected,
    className,
    disabled,
    excludeDate,
    id,
    value,
    blockInsert,
    ...rest
  } = props;

  return (
    <button
      className={cn(
        "flex flex-row items-center min-h-[14px] lg:min-h-[16px] 2xl:min-h-[32px] bg-[--green100] justify-center not-italic font-semibold text-xs text-shade-six rounded-md transition-colors duration-300",
        className,
        {
          ["bg-checker-availability [&>svg]:text-shade-ten bg-cover bg-transparent bg-no-repeat"]:
            excludeDate && !blockInsert,
          ["text-shade-three  bg-shade-two"]:
            state === AvailabilitySlotProgress.START &&
            isSelected &&
            !excludeDate,
          ["border border-solid bg-transparent pointer-events-none [&_*]:hidden"]:
            state !== AvailabilitySlotProgress.START &&
            isSelected &&
            !excludeDate,
          ["!border-white h-8"]: state === AvailabilitySlotProgress.COMPLETE,
          ["pointer-events-none cursor-not-allowed bg-shade-eleven"]:
            blockInsert,
        },
      )}
      disabled={disabled ? disabled : state !== AvailabilitySlotProgress.START}
      onClick={() =>
        setIsSelected && setIsSelected({ id, value, isSelected: !isSelected })
      }
      {...rest}
    >
      <>
        <p
          className={cn("hidden truncate overflow-hidden mr-2", {
            hidden: excludeDate || blockInsert,
            "lg:block": !(excludeDate || blockInsert),
          })}
        >
          {disabled
            ? t("availability.not_available_text", {
                defaultValue: "Not Available",
              })
            : !isSelected
            ? t("availability.available_text", { defaultValue: "Available" })
            : state === AvailabilitySlotProgress.START
            ? t("availability.not_available_text", {
                defaultValue: "Not Available",
              })
            : ""}
        </p>
        {blockInsert ? (
          <BlockIcon className="fill-brand w-2.5 md:w-5 h-auto" />
        ) : (
          <div className="lg:hidden">
            {!excludeDate &&
              (isSelected ? (
                <CrossIcon className="stroke-shade-three w-2.5 md:w-4 h-2.5" />
              ) : (
                <CheckIcon className="stroke-brand-dark-green w-2.5 md:w-4 h-2.5" />
              ))}
          </div>
        )}
      </>
    </button>
  );
}

export default AvailabilityItem;
